<p-panel header="{{'pages_titles.vehicles.list' | translate}}">
    <app-loader *ngIf="loadingSpinner"></app-loader>

    <ng-template pTemplate="icons">
        <button  *ngIf="!noDataFound" pButton class="p-panel-header-icon p-link" (click)="exportAsXLSX()">
            <span class="pi pi-download"></span>
        </button>
    </ng-template>

    <div *ngIf="noDataFound && !loadingSpinner" class="text-center">
        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
        <p class="no-data-found w-100">{{'vehicleListVide' | translate}}</p>
        <button pButton class="mt-3" icon="pi pi-car" iconPos="left" (click)="goAddVehicle()" type="button"
            label="{{'pages_titles.vehicles.add' | translate}}"></button>
    </div>

    <div *ngIf="!noDataFound && !loadingSpinner">
        <form class="w-100 center" [formGroup]="getFiltersForm">

            <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()" class="search-global w-100"
                placeholder="{{'Start_recherche'| translate}}" type="text" name="searchTextLicense"
                formControlName="searchTextLicense" />

            <table class="table-form" #dataTable="mfDataTable" [mfData]="vehicles" #mf="mfDataTable"
                [mfRowsOnPage]="10">
                <thead class="thead-form">
                    <tr>
                        <th scope="col"> {{'Actions' | translate}}</th>
                        <th>
                            <mfDefaultSorter by="License">{{'LicensePlate' | translate}}</mfDefaultSorter>
                        </th>
                        <th scope="col">
                            <mfDefaultSorter by="brand">{{'Brand' | translate}}</mfDefaultSorter>
                        </th>
                        <th scope="col">
                            <mfDefaultSorter by="model">{{'Model' | translate}}</mfDefaultSorter>
                        </th>
                        <th scope="col">
                            <mfDefaultSorter by="username">{{'USER' | translate}}</mfDefaultSorter>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="not-display"></tr>
                    <tr class="not-display">
                        <td></td>
                        <td>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText (ngModelChange)="paginateChange($event);onFilterChange()"
                                        class="w-100" placeholder="{{'Start_recherche'| translate}}" type="text"
                                        name="searchTextLicense" formControlName="searchTextLicense" />
                                </span>
                            </div>
                        </td>
                        <td>
                            <div>

                            <p-dropdown appendTo="body" class="d-block" [options]="brands" optionLabel="name"
                            formControlName="searchTextBrand" placeholder="{{'select' | translate}}"
                            (onChange)="onChangeBrand($event);paginateChange($event);onFilterChange()"></p-dropdown>
                            </div>
                        </td>

                        <td>
                            <div>
                                <p-dropdown [disabled]="!models" appendTo="body" class="d-block" [options]="models" optionLabel="name"
                                formControlName="searchTextModel" placeholder="{{'select' | translate}}"
                                (onChange)="onChangeModel($event);paginateChange($event);onFilterChange()"></p-dropdown>
                            </div>
                        </td>

                        <td>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input type="text" (ngModelChange)="paginateChange($event);onFilterChange()"
                                        pInputText name="searchTextUsername" formControlName="searchTextUsername"
                                        class="w-100" placeholder="{{'Start_recherche'| translate}}">
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let vehicles of mf.data ; index as i">
                        <td attr.data-label="{{'Actions' | translate}}" class="slot">
                            <div>
                                <i class="pi pi-pencil text-primary ml-1 mr-1" (click)="openDialog(vehicles, 'edit')"
                                    pTooltip="{{'Edit' | translate}} " tooltipPosition="bottom"></i>
                                <i class="pi pi-trash text-danger  ml-1 mr-1" (click)="openDialog(vehicles, 'delete')"
                                    pTooltip="{{'Delete' | translate}}" tooltipPosition="bottom"></i>
                            </div>
                        </td>
                        <td attr.data-label="{{'LicensePlate' | translate}}" class="slot">
                            <p class="text-center overflow-auto"><strong>{{vehicles.License}}</strong></p>
                        </td>
                        <td attr.data-label="{{'Brand' | translate}}" class="slot">
                            <p class="text-center overflow-auto">{{vehicles.brand}}</p>
                        </td>

                        <td attr.data-label="{{'Model' | translate}}" class="slot">
                            <p class="text-center overflow-auto">{{vehicles.model}}</p>
                        </td>

                        <td attr.data-label="{{'USER' | translate}}" class="slot">
                            <p *ngIf="vehicles.user" class="text-center p-link"
                                (click)="navigateToUsersList(vehicles.username)">
                                {{vehicles.username}}
                            </p>
                            <p *ngIf="!vehicles.user" class="text-center">
                                {{vehicles.username}}
                            </p>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5">
                            <mfBootstrapPaginator class="paginator" #Paginator [rowsOnPageSet]="[10,25,50,75]">
                            </mfBootstrapPaginator>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <div *ngIf="noDataSearch && !noDataFound" class="no-data-search">
                <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
            </div>
        </form>
    </div>
</p-panel>

<p-dialog header="{{'edit_vehicle' | translate}}" [(visible)]="displayEditModal" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    <app-loader *ngIf="loadingSpinnerModal"></app-loader>
        <div  *ngIf="!loadingSpinnerModal">
            <div class="form-group">
                <label for="email">{{'LicensePlate' | translate}}<span class="text-danger">*</span></label>
                <input type="text" id="licensePlate" name="licensePlate" placeholder="liscence" required pInputText
                    (input)="handleLicensePlate($event)" fullWidth shape="rectangle"
                    [(ngModel)]="electricVehicle.licensePlate" class="w-100" />
                <ng-container
                    *ngIf="(licensePlateControl.invalid || isLicensePlateUsed || licensePlateControl.touched) && (licensePlateControl.dirty  || isSubmitted)">
                    <p class="text-danger" *ngIf="licensePlateControl?.errors?.required">
                        {{'errors.licensePlate.required' | translate}}
                    </p>
                    <p class="text-danger" *ngIf="isLicensePlateUsed">{{'errors.licensePlate.used' | translate}}</p>
                </ng-container>
            </div>

            <!-- user -->
            <div class="form-group">
                <label class="mr-3" for="model">{{'UserVehicule' | translate}}</label>
                <p-dropdown appendTo="body" [options]="employees" name="employees" [(ngModel)]="electricVehicle.user"
                    optionLabel="username" optionValue="id"></p-dropdown>
            </div>

            <!-- brand -->
            <div class="form-group">
                <label class="mr-5" for="local">{{'Brand' | translate}}<span class="text-danger">*</span></label>
                <p-dropdown appendTo="body" [options]="brands" name="brands" [(ngModel)]="electricVehicle.brand"
                    optionLabel="name" optionValue="_id" (onChange)="onChangeBrand()"></p-dropdown>
            </div>

            <!-- model -->
            <div class="form-group">
                <label class="mr-5" for="model">{{'Model' | translate}}<span class="text-danger">*</span></label>
                <p-dropdown appendTo="body" [options]="models" name="models" [(ngModel)]="electricVehicle.model"
                    optionLabel="name" optionValue="_id"></p-dropdown>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <p-button  *ngIf="!loadingSpinnerModal" icon="pi pi-check" (click)="displayEditModal=false;editVehicle()"
                label=" {{'actions.update' | translate}}" styleClass="p-button-primary"></p-button>
        </ng-template>

</p-dialog>


<p-dialog position="bottom" header="{{'Delete' | translate}}" [(visible)]="displayDeleteModal" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_delete' | translate}}
    <strong>{{ electricVehicle.licensePlate }} </strong> ?
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayDeleteModal=false;deleteVehicle()"
            label=" {{'actions.delete' | translate}}" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>